import { z, type ZodType } from 'zod';
import { type Country, getConfig } from '@/constants/config';

const getSEUsersMeResponseSchema = z.object({
  email: z.string(),
  mobile: z.string(),
  isLatestTermsAndConditionsAcknowledged: z.boolean(),
});

export const getUKUsersMeResponseSchema = getSEUsersMeResponseSchema.and(
  z.object({
    address: z.object({
      buildingNumber: z.string().optional(),
      buildingName: z.string().optional(),
      street: z.string(),
      postCode: z.string(),
      town: z.string(),
    }),
  }),
);

// TODO: FI - Add schema
const getFIUsersMeResponseSchema = z.object({});

const getUsersMeResponseSchemaMap = {
  SE: getSEUsersMeResponseSchema,
  UK: getUKUsersMeResponseSchema,
  FI: getFIUsersMeResponseSchema,
} satisfies Record<Country, ZodType>;

export const getUsersMeResponseSchema = getUsersMeResponseSchemaMap[getConfig().country];
